import { useQuery } from "react-query";
import { ApiError, api } from "utils/api";
import { SystemStats } from "../types";

const getSystemStats = () => api(`/stats`);

const useSystemStats = () =>
  useQuery<SystemStats, ApiError>(["system", "stats"], () => getSystemStats());

export { useSystemStats };
